import Vue from 'vue'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { vue } from '@/main.js'
import { dataFields } from './utils.js'

// Retorna os cadastros de uma equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/tratamento-odontologico-concluido/${cod_ibge}/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await Vue.prototype.$api.get(
      `/app/tratamento-odontologico-concluido/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna o nome da cor de acordo com o valor
 * @param {int} valor - Valor numérico
 */
export function getCorTextoResultado(valor) {
  if (valor >= 60) {
    return 'green-color'
  } else {
    return 'red-color'
  }
}

export function generatePdf(cadastros, selectEquipe, micro_area) {
  let title_pdf = 'Tratamentos concluídos'
  let titlePdfSave = utils.methods.titlePdf('Tratamentos concluídos')
  let description_pdf = 'Tratamento iniciado na primeira consulta e concluído'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'CONCLUÍDO',
    'CPF',
    'CNS',
    'MICROÁREA',
    'CADASTRADO POR',
    'NM',
  ]

  const doc = new jsPDF({
    orientation: 'l',
    unit: 'pt',
    format: 'a4',
    ...utils.methods.encryptionPdf(),
  })

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        200,
        'l'
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'INE',
            value: selectEquipe.ine_esb,
          },
          {
            label: 'Microárea',
            value: micro_area,
          },
        ],
        verticalPosition,
        'l'
      )

      // Linhas principais + linha de detalhe (que receberá a tabela interna)
      const bodyRows = []
      cadastros.forEach((item) => {
        bodyRows.push([
          item.no_cidadao,
          item.dt_nascimento != null
            ? utils.methods.formatDate(item.dt_nascimento)
            : '',
          item.no_mae,
          item.ult_tratam_concluido != null
            ? utils.methods.formatDate(item.ult_tratam_concluido)
            : '',
          item.nu_cpf,
          item.nu_cns,
          item.micro_area,
          item.no_profissional,
          item.num_trat_concluido > 0 ? 'Sim' : '',
        ])

        const dados = item.dados != null ? JSON.parse(item.dados) : null

        bodyRows.push({
          isDetail: true,
          dados,
          cells: [''], // 1 célula que vai ocupar a largura toda via colspan
        })
      })

      doc.autoTable({
        head: [headers_pdf],
        body: bodyRows,
        startY: verticalPosition,
        theme: 'striped',
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          fontSize: 6,
          halign: 'center',
        },
        styles: { cellPadding: 6 },

        // Faz a linha de detalhe ocupar 100% (colSpan = total de colunas)
        didParseCell: function (data) {
          const raw = data.row?.raw
          if (raw && raw.isDetail && data.section === 'body') {
            data.cell.colSpan = data.table.columns.length
            data.cell.styles.fillColor = [245, 245, 245]
            data.cell.styles.halign = 'left'
            data.cell.styles.cellPadding = {
              top: 3,
              right: 2,
              bottom: 3,
              left: 2,
            }
            data.cell.text = [''] // o conteúdo será desenhado manualmente
          }
        },

        // Desenha a TABELA INTERNA ocupando 100% da largura da célula
        didDrawCell: function (data) {
          const raw = data.row?.raw
          if (!raw || !raw.isDetail || data.section !== 'body') return

          // evita render duplicado quando a mesma linha se estende para outra página
          if (raw.__innerRendered) return
          // garante que só dispare na primeira célula da linha
          if (
            typeof data.column?.index !== 'undefined' &&
            data.column.index !== 0
          )
            return

          const docRef = data.doc
          const cell = data.cell

          const innerHead = [['Anterior', 'Tempo', 'Atual']]

          const innerBody = [
            [
              utils.methods.formatDate(raw.dados?.tc_anterior) ?? '',
              raw.dados?.tempo_meses != null
                ? `${raw.dados?.tempo_meses} meses`
                : '',
              utils.methods.formatDate(raw.dados?.tc_atual) ?? '',
            ],
          ]

          const paddingX = 8
          const paddingY = 8
          const startY = cell.y // gruda no topo da célula de detalhe

          // página antes
          const pageBefore = docRef.internal.getCurrentPageInfo().pageNumber
          const pageHeight = docRef.internal.pageSize.getHeight()

          docRef.autoTable({
            head: innerHead,
            body: innerBody,
            startY,
            // 100% da largura da célula
            margin: {
              left: cell.x,
              right:
                docRef.internal.pageSize.getWidth() - (cell.x + cell.width),
            },
            tableWidth: cell.width,
            theme: 'grid',
            styles: {
              fontSize: 6,
              halign: 'center',
              cellPadding: {
                top: paddingY / 2,
                bottom: paddingY / 2,
                left: paddingX / 2,
                right: paddingX / 2,
              },
            },
            headStyles: {
              fillColor: [230, 230, 230],
              textColor: 20,
              fontStyle: 'bold',
            },
            pageBreak: 'avoid',
          })

          const last = docRef.lastAutoTable
          const pageAfter = docRef.internal.getCurrentPageInfo().pageNumber

          if (pageAfter > pageBefore) {
            // se a subtabela foi jogada para a próxima página: limita a altura da linha atual
            const availableCurrentPage = pageHeight - cell.y - paddingY
            data.row.height = Math.max(data.row.height, availableCurrentPage)
          } else {
            // se a subtabela coube na mesma página: ajusta pela altura real
            const neededHeight = last.finalY - cell.y + paddingY
            if (neededHeight > data.row.height) data.row.height = neededHeight
          }

          // marca como renderizada para esta linha de detalhe
          raw.__innerRendered = true
        },
      })

      const pageWidth = doc.internal.pageSize.getWidth()

      const lineWidth = pageWidth * 0.35
      const x1 = (pageWidth - lineWidth) / 2
      const x2 = x1 + lineWidth

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY, x1, x2, 'l')

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export function percentualMunicipio(dadosDaTabelaResultado) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  const dadosDoMunicipio = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 1 &&
      item.ibge === store.state.cod_ibge &&
      item.indicador == 43 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDoMunicipio === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDoMunicipio.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado
  classificacao = dados.classificacao

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

export function percentualEquipe(dadosDaTabelaResultado, nuIne) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaEquipe = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 2 &&
      item.ine === nuIne &&
      item.indicador == 43 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaEquipe === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: '',
    }
  }

  let dados = JSON.parse(dadosDaEquipe.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado
  classificacao = dados.classificacao

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}

export function percentualMicroArea(
  dadosDaTabelaResultado,
  nu_ine,
  micro_area
) {
  let numerador = 0
  let denominador = 0
  let resultado = 0
  let classificacao = ''

  const hoje = new Date()
  const mesAtual = hoje.getMonth() + 1
  const anoAtual = String(hoje.getFullYear())
  const mesAnoAtual = `${mesAtual}/${anoAtual}`

  let dadosDaMicroArea = dadosDaTabelaResultado.find(
    (item) =>
      item.nivel == 3 &&
      item.ine == nu_ine &&
      item.micro_area === micro_area &&
      item.indicador == 43 &&
      item.mes_ano === mesAnoAtual
  )

  if (dadosDaMicroArea === undefined) {
    return {
      numerador: 0,
      denominador: 0,
      resultado: 0,
      classificacao: classificacao,
    }
  }

  let dados = JSON.parse(dadosDaMicroArea.dados)

  numerador = dados.numerador
  denominador = dados.denominador
  resultado = dados.resultado
  classificacao = dados.classificacao

  return {
    numerador: numerador,
    denominador: denominador,
    resultado: resultado,
    classificacao: classificacao,
  }
}
